namespace TabAurous {
    export interface TransactionRequest extends Serenity.ListRequest {
        LotNos?: string[];
        TransIds?: number[];
        TransItemId?: number;
        SubBagNo?: number;
        BagNos?: string[];
        UserId?: number;
        ProcessId?: number;
        FinancialYearId?: number;
        InStock?: boolean;
        SKUs?: string[];
        IsJewellery?: boolean;
        IsOrdered?: boolean;
        RefStockId?: number;
        RefMovementId?: number;
        StockAllocation?: boolean;
        Studded?: number;
        OrderStatusId?: number;
        StatusId?: number;
        StockIds?: number[];
        LedgerIds?: number[];
        RefVoucherTypeId?: number;
        StartDate?: string;
        EndDate?: string;
        TransItemIds?: number[];
        AgainstVoucherTypeId?: number;
        AgainstVoucherNo?: string;
        InvoiceNo?: string;
        AgainstInvoiceNo?: string;
        ReferenceType?: string;
        Type?: number;
        ECommOrderIds?: number[];
        StockIn?: boolean;
        PostingTrans?: CommonTrans;
        IsApproved?: boolean;
        IsSubmitted?: boolean;
        CategoryIds?: number[];
        SubCategoryIds?: number[];
        SalesFilter?: number;
        ReportHtml?: string;
        FormatType?: string;
        QuotationReport?: number[];
        Entities?: TabAurous.Common.MasterTransaction[];
        ShapeGroup1?: string[];
        ShapeGroup2?: string[];
        CustomerPrefix?: string;
        ApplicableOn?: number;
        CompanyIds?: number[];
        FinancialYearIds?: number[];
        ImageName?: string;
        Authorize?: boolean;
        ProductId?: number;
        DesignId?: number;
        ProductCode?: string;
        SKU?: string;
        DesignCode?: string;
        ProductCodes?: string[];
        DesignCodes?: string[];
        AttributeId?: number;
        LedgerId?: number;
        POSCustomerId?: number;
        ProductTypeId?: number;
        ProductTypeIds?: number[];
        ItemTypeId?: number;
        CategoryId?: number;
        KaratId?: number;
        MetalColorId?: number;
        ItemTypeIds?: number[];
        Line_No?: number;
        LineNos?: number[];
        ProductIds?: number[];
        AttributeIds?: number[];
        AttributeTypeId?: number;
        AttributeTypeIds?: number[];
        VoucherTypeId?: number;
        TransId?: number;
        LotNo?: string;
        BagNo?: string;
        DepartmentId?: number;
        DepartmentIds?: number[];
        IsNew?: boolean;
        HasBom?: boolean;
        ForExchange?: boolean;
        IsFeatured?: boolean;
        IsEnquiry?: boolean;
        IsCustomerItem?: boolean;
        EnquiryType?: string;
        ParentDesign?: string;
        PartyIds?: number[];
        VoucherNo?: string;
        VoucherNos?: string[];
        RefNo?: string;
        Iteration?: string;
        ShapeId?: number;
        ShapeIds?: number[];
        StoneSizeId?: number;
        SieveId?: number;
        PartyId?: number;
        CompanyId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefVoucherId?: number;
        RefTransIds?: number[];
        FromWeight?: number;
        ToWeight?: number;
        FromRate?: number;
        ToRate?: number;
        Products?: TabAurous.Common.CommonProduct[];
        PrintSpecSheet?: boolean;
        CategoryNames?: string[];
        SubCategoryNames?: string[];
        Code?: number;
    }
}
